export default {
  金币: '金币',
  会员免费: '会员免费',
}
